import { Check } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React, { useState } from 'react';
import { LabelWithoutEventBubbling } from "../../helper/components/LabelWithoutEventBubbling.js";
import { __DEV__ } from "../../helper/dev.js";
import { useErrorProps } from "../../helper/hooks/useErrorProps.js";
import { useStableId } from "../../helper/hooks/useStableId.js";
import styles from "./Textarea.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const replaceWithCharsLeft = (carry, value) => carry.replace('@@charsLeft@@', value.toString());
export const Textarea = ({
  className,
  error,
  inputRef,
  id,
  label,
  maxLength,
  maxLengthMessage,
  onFocus,
  onBlur,
  valid,
  value,
  highlighted,
  fixedLabel,
  autoHeight,
  ...props
}) => {
  const [focused, setFocused] = useState(false);
  const inputId = useStableId(id);
  const charsLeft = maxLength && typeof value !== 'undefined' ? maxLength - value.toString().length : maxLength;
  const {
    errorMessage,
    errorInputProps
  } = useErrorProps({
    error
  });
  const isEmpty = !value && !props.placeholder;
  const classes = classnames(styles.textarea, {
    [styles.focused]: focused,
    [styles.empty]: isEmpty,
    [styles.error]: !!error,
    [styles.disabled]: props.disabled,
    [styles.highlighted]: highlighted,
    [styles.fixedLabel]: fixedLabel
  }, className);
  const textAreaClasses = classnames(styles.textareaElement, valid && styles.textareaIcon);
  function handleOnFocus(e) {
    setFocused(true);
    onFocus?.(e);
  }
  function handleOnBlur(e) {
    setFocused(false);
    onBlur?.(e);
  }
  if (maxLengthMessage && !maxLengthMessage?.includes('@@charsLeft@@') && __DEV__) {
    // eslint-disable-next-line no-console
    console.error('[Invalid props]: did not find "@@charsLeft@@" in maxLengthMessage! For more information, read <Textarea /> docs');
  }
  const textAreaProps = {
    id: inputId,
    ref: inputRef,
    className: textAreaClasses || undefined,
    onBlur: handleOnBlur,
    onFocus: handleOnFocus,
    value,
    maxLength,
    ...props
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.input,
      children: [/*#__PURE__*/_jsx(LabelWithoutEventBubbling, {
        htmlFor: inputId,
        className: classnames(styles.label, valid && styles.labelWithIconSpace),
        children: /*#__PURE__*/_jsx("span", {
          children: label
        })
      }), autoHeight ? /*#__PURE__*/_jsxs("div", {
        className: styles.autoHeightWrapper,
        children: [/*#__PURE__*/_jsx("div", {
          className: classnames(textAreaClasses, styles.autoHeightIndicator),
          "aria-hidden": true,
          children: value
        }), /*#__PURE__*/_jsx("textarea", {
          ...textAreaProps,
          ...errorInputProps
        })]
      }) : /*#__PURE__*/_jsx("textarea", {
        ...textAreaProps
      }), valid && /*#__PURE__*/_jsx(Check, {
        className: styles.checkmarkIcon
      })]
    }), maxLengthMessage && charsLeft && /*#__PURE__*/_jsx("div", {
      className: styles.maxLength,
      children: replaceWithCharsLeft(maxLengthMessage, charsLeft)
    }), errorMessage]
  });
};